import { RoleCode } from "@CommonUtils/RolesPermissions";

export const ROLE_OPTIONS = [
  { label: "Admin", value: RoleCode.ADMIN },
  { label: "Operator", value: RoleCode.OPERATOR },
  { label: "Developer", value: RoleCode.DEVELOPER },
  { label: "Minor Reviewer", value: RoleCode.MINOR_REVIEWER },
] as const;
